import NewsItem from './NewsItem'
import { NewsPermission } from './types'

const NewsView = ({
  newsItem,
  isPending,
  teamName,
  editPermission,
}: {
  newsItem: wowaudit.NewsItem | undefined
  isPending: boolean
  teamName?: string
  editPermission: NewsPermission
}) => {
  if (isPending || !newsItem) return null

  return (
    <NewsItem
      item={newsItem}
      teamName={teamName}
      editPermission={editPermission}
    />
  )
}

export default NewsView
